<template>
  <div class="select">
    <div
      @click="toggleSelect"
      class="select-dropdown"
      :class="{ visible: isVisible }"
    >
      <span>{{ heading }}</span>
      <img :src="require(`@/assets/arrow-down.png`)" />
    </div>
    <ul class="select-options" :class="{ visible: isVisible }">
      <li
        class="select-options__item"
        v-for="option in options"
        :key="option"
        @click="optionClick(option)"
      >
        <span
          class="checkmark"
          :class="{ checked: selectedOptions.includes(option) }"
        ></span>
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Select',
  data() {
    return {
      isVisible: false,
      selectedOptions: [],
    };
  },
  props: ['heading', 'property', 'queryParam'],
  computed: {
    ...mapState({
      flatProperties: state => state.browser.flatProperties,
    }),
    options() {
      return [
        ...new Set([
          ...this.$store.getters.GET_FLATS.filter(
            flat =>
              flat[this.flatProperties['type']] === 'Mieszkanie' &&
              flat[this.flatProperties['status']] !== '3' &&
              Number(flat[this.flatProperties['rooms']]) > 0
          ).map(flat => Math.ceil(flat[this.property])),
        ]),
      ].sort((a, b) => a - b);
    },
  },
  methods: {
    ...mapMutations({
      updateFilter: 'ADD_FILTERS',
    }),
    toggleSelect() {
      this.isVisible = !this.isVisible;
    },
    optionClick(option) {
      if (this.selectedOptions.includes(option)) {
        this.selectedOptions = this.selectedOptions.filter(el => el !== option);
      } else {
        this.selectedOptions = [...this.selectedOptions, option];
      }
    },
  },
  watch: {
    selectedOptions(options) {
      this.$emit('handler', options);
    },
  },
  mounted() {
    this.updateFilter({
      property: this.property,
      from: this.options[0],
      to: this.options[this.options.length - 1],
    });

    const urlParams = new URLSearchParams(window.location.search);
    const initSelected = urlParams.get(this.queryParam);
    if (initSelected) {
      this.selectedOptions = [Number(initSelected)];
    }
  },
};
</script>

<style scoped lang="scss">
.select {
  position: relative;
  width: 100%;
  z-index: 8;
  &:first-of-type {
    z-index: 9;
  }
}

.select-dropdown {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  transition: 0.3s;
  background-color: #fff;
  cursor: pointer;
  border: 2px solid;
  border-color: $lightGray;
  user-select: none;
  @media (hover: hover) {
    &:hover {
      border-color: $primaryColor;
    }
  }
  &.visible {
    border-color: $primaryColor;
  }
  span {
    font-size: 16px;
  }
}

.select-options {
  position: absolute;
  top: calc(100% - 2px);
  width: 100%;
  background-color: #fff;
  font-size: 16px;
  border: 2px solid $primaryColor;
  opacity: 0;
  visibility: hidden;
  max-height: 260px;
  overflow-y: auto;
  &.visible {
    opacity: 1;
    visibility: visible;
  }
  &__item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 15px 35px;
    cursor: pointer;
    transition: 0.2s;
    color: #000;
    @media (hover: hover) {
      &:hover {
        background: $lightGray;
      }
    }
    .checkmark {
      position: absolute;
      top: 14px;
      left: 10px;
      height: 16px;
      width: 16px;
      border: 1px solid;
      border-color: #303030;
      background: transparent;
      border-radius: 4px;
      transition: 0.2s;
      &:after {
        content: '';
        position: absolute;
        display: none;
        left: 2px;
        top: 2px;
        width: 10px;
        height: 10px;
        background: url('../../assets/confirm.svg') no-repeat center;
      }
      &.checked {
        background: $primaryColor;
        border-color: $primaryColor;
        &:after {
          display: block;
        }
      }
    }
  }
}
</style>
